export const FETCH_PROFILES = 'FETCH_PROFILES';
export const FETCH_PROFILE = 'FETCH_PROFILE';
export const POST_PROFILE = 'POST_PROFILE';
export const PUT_PROFILE = 'PUT_PROFILE';

import {
  getProfiles,
  getProfile,
  postProfile,
  putProfile } from '../api';

export const fetchProfiles = (organisationId) => ({
  type: FETCH_PROFILES,
  payload: getProfiles(organisationId)
});

export const fetchProfile = (organisationId, profileId) => ({
  type: FETCH_PROFILE,
  payload: getProfile(organisationId, profileId)
});

export const createProfile = (organisationId, profile) => ({
  type: POST_PROFILE,
  payload: postProfile(organisationId, profile)
});

export const updateProfile = (organisationId, profile) => ({
  type: PUT_PROFILE,
  payload: putProfile(organisationId, profile)
});



// WEBPACK FOOTER //
// ./src/actions/profiles.js